import { getDefaultEnvironment } from '../Support';
import { Navigate, Outlet } from 'react-router-dom';
import { routeUrls } from './RouteUrls';
import {
  DianaFeaturesEnum,
  Loader,
  RequireAuth,
  useCurrentUserStore,
  useEnvironment,
  useHasFeature,
} from '@diana/core';
import { AppLoading } from '../AppLoading';
import { AppError } from '../AppError';

export function RootRedirector() {
  const environment = getDefaultEnvironment();
  if (!environment) {
    return <Navigate to={routeUrls.selectEcosystem.url(null, null)} replace />;
  }

  return <Navigate to={routeUrls.root.url({ environment }, null)} replace />;
}

export function EcosystemRootIndexPath() {
  const environment = useEnvironment();
  const session = useCurrentUserStore((store) => store.info);
  const withHomePage = useHasFeature(DianaFeaturesEnum.HomePage);

  if (!session) return <Loader />;

  return withHomePage ? ( //todo temporary solution until HomePage feature is enabled for all clients
    <Navigate to={routeUrls.home.url({ environment }, {})} />
  ) : (
    <Navigate to={routeUrls.workflows.url({ environment }, {})} />
  );
}

export function EnsureAuth() {
  return (
    <RequireAuth LoadingComponent={AppLoading} ErrorComponent={AppError}>
      <Outlet />
    </RequireAuth>
  );
}
